import { SpatialAggregationType } from "@/types/common";
import { DatasetFilterPayload, H3Configuration } from "@/types/dataset";

import {
  AnalysisDataset,
  AnalysisDatasetFilter,
  WorkspaceDatasetEntry
} from "@lokasi-ai-web-sdk/agent-ui";

/**
 * The SDK keeps proposal extensions open. Types the fields this adapter reads
 * while keeping the SDK's permissive entry contract for malformed proposals.
 */
export type AgentDatasetProposal = WorkspaceDatasetEntry & {
  readonly dataset_spatial_aggregation_type?: SpatialAggregationType;
  readonly filters?: readonly AnalysisDatasetFilter[];
};

/**
 * One attribute's weight, as the agent publishes it (contract S6).
 *
 * The SDK types `attributes[]` as an open record because the backend owns the
 * shape, so the fields this adapter reads are declared here.
 */
export type AgentAttributeWeight = {
  readonly attribute_id?: string;
  readonly weight_score?: number | null;
  readonly include_scoring?: boolean;
};

/** A dataset in the workspace, with the weight fields the SDK leaves open. */
export type AgentWorkspaceDataset = AnalysisDataset & {
  readonly attributes?: readonly AgentAttributeWeight[];
};

export type PendingDataset = {
  id: string;
  filters: DatasetFilterPayload[];
  grid_config: H3Configuration | null;
};

export class RowLimitError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "RowLimitError";
  }
}
